import { FC, ReactNode } from 'react';
import Stack from '@mui/material/Stack';

type StackDirection = 'column' | 'row';

interface StackContainerProps {
  spacing?: number;
  children: ReactNode;
  direction?: StackDirection | { xs: StackDirection; md: StackDirection };
}

export const StackContainer: FC<StackContainerProps> = ({ spacing = 2, direction = 'column', children }) => {
  return (
    <Stack direction={direction} spacing={spacing}>
      {children}
    </Stack>
  );
};
